export default "__VITE_ASSET__DWvAGccY__"